<template>
  <div>
    <div
      v-if="errors"
      class="app-body app flex-row align-items-center">
      <main class="main">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="alert alert-danger">
              <p>
                Произошла непредвиденная ошибка, попробуйте обновить страницу.
              </p>
              <p>
                {{ errors }}
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
    <template v-else>
      <router-view/>
      <toast
        :html="true"
        position="se"/>
    </template>
  </div>
</template>

<script>
  import {Toast} from 'vuex-toast'
  import 'vuex-toast/dist/vuex-toast.css'
  import {mapState} from 'vuex'

  export default {
    name: 'App',
    components: {
      Toast
    },
    computed: {
      ...mapState({
        errors: state => state.globalStore.errors
      })
    }
  }
</script>
<style>
  /*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  /*}*/
  .toast {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// App.vue?c29a12f6